
import React, { useEffect } from "react";
import { useHistoryOperations } from "@/hooks/useHistoryOperations";
import { EntityHistory } from "@/components/common/EntityHistory";

interface JobHistoryProps {
  jobId: string | undefined;
}

export const JobHistory = ({ jobId }: JobHistoryProps) => {
  const { history, loading, fetchHistory } = useHistoryOperations('job');

  // Fetch history when component mounts or jobId changes
  useEffect(() => {
    if (jobId) {
      fetchHistory(jobId);
    }
  }, [jobId, fetchHistory]);

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold mb-4">Job History</h3>
      <EntityHistory history={history} loading={loading} />
    </div>
  );
};
